import React, { useState } from 'react';
import CenteredModal from '../../../common/CenteredModal';
import { PlusIcon } from '@heroicons/react/24/outline';
import { formStyles } from '../../utils/formStyles';

export function ExhibitionQuickCreate({ quickCreateData, setQuickCreateData, handleQuickCreate }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setQuickCreateData(prev => ({
      ...prev,
      exhibition: {
        ...prev.exhibition,
        [name]: value
      }
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!quickCreateData.exhibition.name || !quickCreateData.exhibition.locations || !quickCreateData.exhibition.start_date || !quickCreateData.exhibition.end_date) {
      alert('Bitte füllen Sie alle erforderlichen Felder aus.');
      return;
    }
    setLoading(true);
    try {
      await handleQuickCreate('exhibitions');
      setQuickCreateData(prev => ({
        ...prev,
        exhibition: {
          name: '',
          locations: '',
          start_date: '',
          end_date: ''
        }
      }));
      setOpen(false);
    } catch (error) {
      console.error('Error creating exhibition:', error);
      alert(`Error creating exhibition: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="ml-1 px-2 py-1 rounded bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-200 hover:bg-blue-200 dark:hover:bg-blue-800 transition"
        onClick={() => setOpen(true)}
        title="Neue Ausstellung anlegen"
      >
        <PlusIcon className="w-5 h-5" />
      </button>
      <CenteredModal open={open} onClose={() => setOpen(false)} title="Neue Ausstellung anlegen">
        <div className="space-y-4">
          <div>
            <label className="block text-xs font-semibold mb-1 text-gray-700 dark:text-gray-200">Name</label>
            <input
              type="text"
              name="name"
              value={quickCreateData.exhibition.name || ''}
              onChange={handleChange}
              className="w-full rounded border border-gray-300 dark:border-zinc-600 px-3 py-2 bg-white dark:bg-zinc-900 text-gray-900 dark:text-white"
              required
            />
          </div>
          <div>
            <label className="block text-xs font-semibold mb-1 text-gray-700 dark:text-gray-200">Ort</label>
            <input
              type="text"
              name="locations"
              value={quickCreateData.exhibition.locations || ''}
              onChange={handleChange}
              className="w-full rounded border border-gray-300 dark:border-zinc-600 px-3 py-2 bg-white dark:bg-zinc-900 text-gray-900 dark:text-white"
              required
            />
          </div>
          <div className="grid grid-cols-2 gap-2">
            <div>
              <label className="block text-xs font-semibold mb-1 text-gray-700 dark:text-gray-200">Startdatum</label>
              <input
                type="date"
                name="start_date"
                value={quickCreateData.exhibition.start_date || ''}
                onChange={handleChange}
                className={formStyles.dateInput}
                required
              />
            </div>
            <div>
              <label className="block text-xs font-semibold mb-1 text-gray-700 dark:text-gray-200">Enddatum</label>
              <input
                type="date"
                name="end_date"
                value={quickCreateData.exhibition.end_date || ''}
                onChange={handleChange}
                className={formStyles.dateInput}
                required
              />
            </div>
          </div>
          <div className="flex justify-end gap-2 mt-4">
            <button 
              type="button" 
              onClick={() => setOpen(false)} 
              className="px-4 py-2 rounded bg-gray-200 dark:bg-zinc-700 text-gray-800 dark:text-gray-200"
              disabled={loading}
            >
              Abbrechen
            </button>
            <button 
              type="button"
              onClick={handleSubmit}
              className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={loading}
            >
              {loading ? 'Wird gespeichert...' : 'Anlegen'}
            </button>
          </div>
        </div>
      </CenteredModal>
    </>
  );
} 